// import React, { useRef, useEffect } from "react";

// export default function StarsBackground() {
//   const canvasRef = useRef(null);

//   useEffect(() => {
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext("2d");
//     let w = (canvas.width = canvas.offsetWidth);
//     let h = (canvas.height = canvas.offsetHeight);

//     const onResize = () => {
//       w = canvas.width = canvas.offsetWidth;
//       h = canvas.height = canvas.offsetHeight;
//     };
//     window.addEventListener("resize", onResize);

//     const stars = new Array(80).fill().map(() => ({
//       x: Math.random() * w,
//       y: Math.random() * h,
//       r: Math.random() * 1.2 + 0.5,
//       dx: (Math.random() - 0.5) * 0.2,
//       dy: (Math.random() - 0.5) * 0.2,
//     }));

//     function draw() {
//       ctx.clearRect(0, 0, w, h);
//       stars.forEach((s) => {
//         ctx.beginPath();
//         ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
//         ctx.fillStyle = "rgba(30, 199, 255, 0.8)";
//         ctx.fill();

//         s.x += s.dx;
//         s.y += s.dy;
//         if (s.x < 0 || s.x > w) s.dx *= -1;
//         if (s.y < 0 || s.y > h) s.dy *= -1;
//       });
//       requestAnimationFrame(draw);
//     }

//     draw();
//     return () => window.removeEventListener("resize", onResize);
//   }, []);

//   return (
//     <canvas
//       ref={canvasRef}
//       className="absolute inset-0 w-full h-full overflow-hidden" // << important, scoped to parent
//     />
//   );
// }
// import React, { useRef, useEffect } from "react";

// export default function StarsBackground() {
//   const canvasRef = useRef(null);

//   useEffect(() => {
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext("2d");
//     let w = (canvas.width = canvas.offsetWidth);
//     let h = (canvas.height = canvas.offsetHeight);

//     const onResize = () => {
//       w = canvas.width = canvas.offsetWidth;
//       h = canvas.height = canvas.offsetHeight;
//     };
//     window.addEventListener("resize", onResize);

//     // create stars with twinkle + float properties
//     const stars = new Array(100).fill().map(() => ({
//       x: Math.random() * w,
//       y: Math.random() * h,
//       r: Math.random() * 1.5 + 0.5,
//       dx: (Math.random() - 0.5) * 0.15,
//       dy: (Math.random() - 0.5) * 0.15,
//       phase: Math.random() * Math.PI * 2, // twinkle phase
//       speed: Math.random() * 0.02 + 0.01, // twinkle speed
//     }));

//     function draw() {
//       ctx.clearRect(0, 0, w, h);

//       stars.forEach((s) => {
//         s.phase += s.speed;
//         const opacity = 0.5 + 0.5 * Math.sin(s.phase); // blinking effect

//         ctx.beginPath();
//         ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
//         ctx.fillStyle = `rgba(30,199,255,${opacity})`;
//         ctx.fill();

//         // bubble floating movement
//         s.x += s.dx;
//         s.y += s.dy + Math.sin(s.phase) * 0.05;

//         // wrap-around instead of bounce (feels smoother like bubbles)
//         if (s.x < 0) s.x = w;
//         if (s.x > w) s.x = 0;
//         if (s.y < 0) s.y = h;
//         if (s.y > h) s.y = 0;
//       });

//       requestAnimationFrame(draw);
//     }

//     draw();
//     return () => window.removeEventListener("resize", onResize);
//   }, []);

//   return (
//     <canvas
//       ref={canvasRef}
//       className="absolute inset-0 w-full h-full overflow-hidden"
//     />
//   );
// }
// import React, { useRef, useEffect } from "react";

// export default function BubbleBackground() {
//   const canvasRef = useRef(null);

//   useEffect(() => {
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext("2d");
//     let w = (canvas.width = canvas.offsetWidth);
//     let h = (canvas.height = canvas.offsetHeight);

//     const onResize = () => {
//       w = canvas.width = canvas.offsetWidth;
//       h = canvas.height = canvas.offsetHeight;
//     };
//     window.addEventListener("resize", onResize);

//     class Bubble {
//       constructor() {
//         this.reset();
//       }

//       reset() {
//         this.x = Math.random() * w;
//         this.y = h + Math.random() * 100; // start below screen
//         this.radius = Math.random() * 15 + 10;
//         this.maxRadius = this.radius * 1.5; // grows slightly
//         this.growth = 0.05 + Math.random() * 0.05;
//         this.speed = 0.5 + Math.random() * 0.5;
//         this.opacity = 0.6 + Math.random() * 0.4;
//         this.popped = false;
//       }

//       update() {
//         if (!this.popped) {
//           this.y -= this.speed; // float upward
//           this.radius += this.growth;

//           if (this.radius >= this.maxRadius) {
//             this.popped = true;
//           }
//         } else {
//           this.opacity -= 0.05; // fade out
//           if (this.opacity <= 0) {
//             this.reset();
//           }
//         }
//       }

//       draw(ctx) {
//         ctx.save();
//         ctx.globalAlpha = this.opacity;

//         // Outer bubble (transparent with outline)
//         ctx.beginPath();
//         ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
//         ctx.strokeStyle = "rgba(173, 216, 230, 0.8)";
//         ctx.lineWidth = 2;
//         ctx.stroke();

//         // Inner highlight (shiny reflection)
//         const shineX = this.x - this.radius / 3;
//         const shineY = this.y - this.radius / 3;
//         ctx.beginPath();
//         ctx.arc(shineX, shineY, this.radius / 4, 0, Math.PI * 2);
//         ctx.fillStyle = "rgba(255,255,255,0.6)";
//         ctx.fill();

//         // Pop ripple
//         if (this.popped) {
//           ctx.beginPath();
//           ctx.arc(this.x, this.y, this.radius * 1.2, 0, Math.PI * 2);
//           ctx.strokeStyle = `rgba(255,255,255,${this.opacity})`;
//           ctx.lineWidth = 1.5;
//           ctx.stroke();
//         }

//         ctx.restore();
//       }
//     }

//     const bubbles = new Array(25).fill().map(() => new Bubble());

//     function animate() {
//       ctx.clearRect(0, 0, w, h);
//       bubbles.forEach((bubble) => {
//         bubble.update();
//         bubble.draw(ctx);
//       });
//       requestAnimationFrame(animate);
//     }

//     animate();

//     return () => window.removeEventListener("resize", onResize);
//   }, []);

//   return (
//     <canvas
//       ref={canvasRef}
//       className="absolute inset-0 w-full h-full overflow-hidden"
//     />
//   );
// }
// import React, { useRef, useEffect } from "react";

// export default function BubbleBackground() {
//   const canvasRef = useRef(null);

//   useEffect(() => {
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext("2d");
//     let w = (canvas.width = canvas.offsetWidth);
//     let h = (canvas.height = canvas.offsetHeight);

//     const onResize = () => {
//       w = canvas.width = canvas.offsetWidth;
//       h = canvas.height = canvas.offsetHeight;
//     };
//     window.addEventListener("resize", onResize);

//     class Bubble {
//       constructor() {
//         this.reset();
//       }

//       reset() {
//         this.x = Math.random() * w;
//         this.y = h + Math.random() * 100; // start below screen
//         this.radius = Math.random() * 7 + 5; // smaller bubbles
//         this.maxRadius = this.radius * 1.5; 
//         this.growth = 0.01 + Math.random() * 0.02; // slow growth
//         this.speed = 0.2 + Math.random() * 0.3; // slow upward float
//         this.opacity = 0.5 + Math.random() * 0.3;
//         this.popped = false;
//       }

//       update() {
//         if (!this.popped) {
//           this.y -= this.speed; // float upward
//           this.radius += this.growth;

//           if (this.radius >= this.maxRadius) {
//             this.popped = true;
//           }
//         } else {
//           this.opacity -= 0.03; // fade out slowly
//           if (this.opacity <= 0) {
//             this.reset();
//           }
//         }
//       }

//       draw(ctx) {
//         ctx.save();
//         ctx.globalAlpha = this.opacity;

//         // Outer bubble outline
//         ctx.beginPath();
//         ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
//         ctx.strokeStyle = "rgba(173, 216, 230, 0.8)";
//         ctx.lineWidth = 1.5;
//         ctx.stroke();

//         // Inner highlight (shiny spot)
//         const shineX = this.x - this.radius / 3;
//         const shineY = this.y - this.radius / 3;
//         ctx.beginPath();
//         ctx.arc(shineX, shineY, this.radius / 4, 0, Math.PI * 2);
//         ctx.fillStyle = "rgba(255,255,255,0.6)";
//         ctx.fill();

//         // Pop ripple
//         if (this.popped) {
//           ctx.beginPath();
//           ctx.arc(this.x, this.y, this.radius * 1.3, 0, Math.PI * 2);
//           ctx.strokeStyle = `rgba(255,255,255,${this.opacity})`;
//           ctx.lineWidth = 1;
//           ctx.stroke();
//         }

//         ctx.restore();
//       }
//     }

//     const bubbles = new Array(35).fill().map(() => new Bubble());

//     function animate() {
//       ctx.clearRect(0, 0, w, h);
//       bubbles.forEach((bubble) => {
//         bubble.update();
//         bubble.draw(ctx);
//       });
//       requestAnimationFrame(animate);
//     }

//     animate();

//     return () => window.removeEventListener("resize", onResize);
//   }, []);

//   return (
//     <canvas
//       ref={canvasRef}
//       className="absolute inset-0 w-full h-full overflow-hidden"
//     />
//   );
// }
// import React, { useRef, useEffect } from "react";

// export default function BubbleBackground() {
//   const canvasRef = useRef(null);

//   useEffect(() => {
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext("2d");
//     let w = (canvas.width = canvas.offsetWidth);
//     let h = (canvas.height = canvas.offsetHeight);

//     const onResize = () => {
//       w = canvas.width = canvas.offsetWidth;
//       h = canvas.height = canvas.offsetHeight;
//     };
//     window.addEventListener("resize", onResize);

//     class Bubble {
//       constructor() {
//         this.reset();
//       }

//       reset() {
//         this.x = Math.random() * w;
//         this.y = h + Math.random() * h * 0.5; // start deeper below
//         this.radius = Math.random() * 7 + 5;
//         this.maxRadius = this.radius * 1.5;
//         this.growth = 0.01 + Math.random() * 0.02;
//         this.speed = 0.2 + Math.random() * 0.3;
//         this.opacity = 0.5 + Math.random() * 0.3;
//         this.popped = false;
//       }

//       update() {
//         if (!this.popped) {
//           this.y -= this.speed;
//           this.radius += this.growth;

//           // Pop only if bubble has risen above halfway height
//           if (this.radius >= this.maxRadius && this.y < h * 0.5) {
//             this.popped = true;
//           }
//         } else {
//           this.opacity -= 0.03;
//           if (this.opacity <= 0) {
//             this.reset();
//           }
//         }
//       }

//       draw(ctx) {
//         ctx.save();
//         ctx.globalAlpha = this.opacity;

//         // Outer bubble
//         ctx.beginPath();
//         ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
//         ctx.strokeStyle = "rgba(173, 216, 230, 0.8)";
//         ctx.lineWidth = 1.5;
//         ctx.stroke();

//         // Shiny highlight
//         const shineX = this.x - this.radius / 3;
//         const shineY = this.y - this.radius / 3;
//         ctx.beginPath();
//         ctx.arc(shineX, shineY, this.radius / 4, 0, Math.PI * 2);
//         ctx.fillStyle = "rgba(255,255,255,0.6)";
//         ctx.fill();

//         // Ripple effect on pop
//         if (this.popped) {
//           ctx.beginPath();
//           ctx.arc(this.x, this.y, this.radius * 1.3, 0, Math.PI * 2);
//           ctx.strokeStyle = `rgba(255,255,255,${this.opacity})`;
//           ctx.lineWidth = 1;
//           ctx.stroke();
//         }

//         ctx.restore();
//       }
//     }

//     const bubbles = new Array(35).fill().map(() => new Bubble());

//     function animate() {
//       ctx.clearRect(0, 0, w, h);
//       bubbles.forEach((bubble) => {
//         bubble.update();
//         bubble.draw(ctx);
//       });
//       requestAnimationFrame(animate);
//     }

//     animate();

//     return () => window.removeEventListener("resize", onResize);
//   }, []);

//   return (
//     <canvas
//       ref={canvasRef}
//       className="absolute inset-0 w-full h-full overflow-hidden"
//     />
//   );
// }
import React, { useRef, useEffect } from "react";

export default function BubbleBackground() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    let w = (canvas.width = canvas.offsetWidth);
    let h = (canvas.height = canvas.offsetHeight);

    const onResize = () => {
      w = canvas.width = canvas.offsetWidth;
      h = canvas.height = canvas.offsetHeight;
    };
    window.addEventListener("resize", onResize);

    class Bubble {
      constructor() {
        this.reset();
      }

      reset() {
        this.x = Math.random() * w;
        this.y = h + Math.random() * h * 0.5; // start below canvas
        this.radius = Math.random() * 6 + 4;
        this.maxRadius = this.radius * 1.5;
        this.growth = 0.01 + Math.random() * 0.02;
        this.speed = 0.3 + Math.random() * 0.4;
        this.opacity = 0.5 + Math.random() * 0.3;
        this.popped = false;

        // 👇 Each bubble gets a random burst height (early/mid/full)
        const choice = Math.random();
        if (choice < 0.33) {
          this.burstHeight = h * 0.75; // bursts early
        } else if (choice < 0.66) {
          this.burstHeight = h * 0.5; // bursts halfway
        } else {
          this.burstHeight = h * 0.2; // bursts near top
        }
      }

      update() {
        if (!this.popped) {
          this.y -= this.speed;
          this.radius += this.growth;

          // Pop when reached its burst height
          if (this.y <= this.burstHeight) {
            this.popped = true;
          }
        } else {
          this.opacity -= 0.03;
          if (this.opacity <= 0) {
            this.reset();
          }
        }
      }

      draw(ctx) {
        ctx.save();
        ctx.globalAlpha = this.opacity;

        // Main bubble outline
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
        ctx.strokeStyle = "rgba(173, 216, 230, 0.8)";
        ctx.lineWidth = 1.5;
        ctx.stroke();

        // Highlight
        const shineX = this.x - this.radius / 3;
        const shineY = this.y - this.radius / 3;
        ctx.beginPath();
        ctx.arc(shineX, shineY, this.radius / 4, 0, Math.PI * 2);
        ctx.fillStyle = "rgba(255,255,255,0.6)";
        ctx.fill();

        // Ripple effect when popped
        if (this.popped) {
          ctx.beginPath();
          ctx.arc(this.x, this.y, this.radius * 1.3, 0, Math.PI * 2);
          ctx.strokeStyle = `rgba(255,255,255,${this.opacity})`;
          ctx.lineWidth = 1;
          ctx.stroke();
        }

        ctx.restore();
      }
    }

    const bubbles = new Array(20).fill().map(() => new Bubble());

    function animate() {
      ctx.clearRect(0, 0, w, h);
      bubbles.forEach((bubble) => {
        bubble.update();
        bubble.draw(ctx);
      });
      requestAnimationFrame(animate);
    }

    animate();

    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="absolute inset-0 w-full h-full overflow-hidden"
    />
  );
}
